import { getPortalName } from "@capone/common";

export const PRINT = "Print";
export const TITLE = "Itemized flight receipt";
export const TRAVELER_NAME = "Traveler name";
export const TRAVELERS = "Travelers";
export const CONFIRMATION_NUMBER = "Confirmation #";
export const INVOICE_DATE = "Invoice date";
export const DEPARTURE = "Departure";
export const RETURN = "Return";
export const BASE_FARE = "Base fare";
export const TAXES_AND_FEES = "Taxes and fees";
export const SEAT_SELECTION = "Seat selection";
export const CANCEL_FOR_ANY_REASON = "Cancel For Any Reason";
export const CHANGE_FOR_ANY_REASON = "Change For Any Reason";
export const DISRUPTION_PROTECTION = "Disruption Protection";
export const TOTAL_COST = "Total cost";
export const MMDDYYYY_FORMAT = "MM/DD/YYYY";
export const PAYMENT_INFO = "Payment info";
export const DEFAULT_DOC_ID = "flight-itemized-receipt";
export const COPY1 = `*This total reflects your purchase through ${getPortalName()}.`;
export const TRAVEL_CREDIT_APPLIED = "Capital One Travel Credit Applied";
export const TRAVEL_OFFER_APPLIED = "Capital One Travel Offer Applied";
export const TRAVEL_CREDITS_LINE_ITEM_APPLIED = "Travel credits applied";
export const TRAVEL_OFFER_LINE_ITEM_APPLIED = "Travel offer applied";
